import React from 'react';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { ProductIntro } from './components/ProductIntro';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { WhatsIncluded } from './components/WhatsIncluded';
import { PremiumPackOffer } from './components/PremiumPackOffer';
import { HowItWorks } from './components/HowItWorks';
import { Testimonials } from './components/Testimonials';
import { ExpertSection } from './components/ExpertSection';
import { OfferSection } from './components/OfferSection';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { PromotionSlider } from './components/PromotionSlider';
import { MobileBonusCarousel } from './components/MobileBonusCarousel';
export function App() {
  return <div className="min-h-screen bg-[#F5F1E8] overflow-x-hidden" data-id="element-0">
      <Header data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <ProductIntro data-id="element-4" />
        <ProblemSection data-id="element-5" />
        <SolutionSection data-id="element-6" />
        <WhatsIncluded data-id="element-7" />
        <PremiumPackOffer data-id="element-8" />
        <HowItWorks data-id="element-9" />
        <Testimonials data-id="element-10" />
        <ExpertSection data-id="element-11" />
        <PromotionSlider data-id="element-12" />
        <OfferSection data-id="element-13" />
        <Guarantee data-id="element-14" />
        <FAQ data-id="element-15" />
        <FinalCTA data-id="element-16" />
        <MobileBonusCarousel data-id="element-17" />
      </main>
      <Footer data-id="element-18" />
    </div>;
}